<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="table.itemsPerPage"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      :footer-props="{
        'items-per-page-options': table.itemsPerPageOptions,
        itemsPerPageText: this.$t('defaults.table.items-per-page-text'),
        pageText: this.$t('defaults.table.page-text'),
      }"
      :no-data-text="$t('defaults.table.no-data-text')"
      :loading-text="$t('defaults.table.loading-text')"
      :options.sync="table.options"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.logTypeName`]="{ item }">
        <v-chip outlined>{{ item.logTypeName }}</v-chip>
      </template>
      <template v-slot:[`item.actionTypeName`]="{ item }">
        <v-chip outlined>{{ item.actionTypeName }}</v-chip>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <div class="d-flex align-center py-1">
          <v-avatar
            :title="item?.actionByUser"
            class="mr-2"
            size="36"
            color="primary"
          >
            <span class="white--text subtitle-1">
              {{ item?.actionByUser?.charAt(0)?.toUpperCase() }}</span
            ></v-avatar
          >
          <div>
            <div class="mb-1 body-1" v-html="item.description"></div>
            <p class="mb-0 body-2">
              {{ formatDate(item.logDateTime, "dd.MM.yyyy HH:mm") }}
            </p>
          </div>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                @click="handleViewDetails(item)"
              >
                <v-icon size="24"> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("defaults.button.view") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <BaseLogDetails
      v-if="detailsModal"
      :modal="detailsModal"
      :item="selectedItem"
      @closeModal="handleCloseDetailsModal"
    ></BaseLogDetails>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { getLogs } from "@/services/log";
import BaseLogDetails from "@/components/BaseLog/BaseLogDetails.vue";

export default {
  mixins: [tableMixins],
  components: { BaseLogDetails },
  props: {
    searchParams: Object,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("logs.list.table.headers.description"),
          value: "description",
          sortable: false,
          width: "70%",
        },
        {
          text: this.$t("logs.list.table.headers.log-type"),
          value: "logTypeName",
          sortable: false,
        },
        {
          text: this.$t("logs.list.table.headers.action-type"),
          value: "actionTypeName",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      detailsModal: false,
      selectedItem: null,
    };
  },
  methods: {
    handleViewDetails(item) {
      this.selectedItem = item;
      this.detailsModal = true;
    },
    handleCloseDetailsModal() {
      this.selectedItem = null;
      this.detailsModal = false;
    },
    handleFetchItems() {
      this.table.options.page = 1;
      this.table.page = 1;
      this.fetchItems();
    },
    fetchItems() {
      this.loading.table = true;
      getLogs({
        pageSize: this.table.itemsPerPage,
        pageNumber: this.table.page,
        ...this.searchParams,
      })
        .then((response) => {
          this.table.items = response.items;
          this.table.totalCount = response.totalCount;

          if (
            response.totalCount <=
            (this.table.options.page - 1) * this.table.itemsPerPage
          ) {
            this.table.options.page = 1;
          }
        })
        .catch(() => {
          this.table.items = [];
          this.table.totalCount = 0;
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
  },
  mounted() {
    this.$eventBus.$on("fetchLogs", this.handleFetchItems);
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchLogs", this.handleFetchItems);
  },
};
</script>
